"use client";

import { ScrollReveal } from "@/components/ui/scroll-reveal";

export function Testimonials() {
  return (
    <section className="py-20 px-6">
      <div className="max-w-4xl mx-auto">
        <ScrollReveal>
          <div className="rounded-2xl border border-white/[0.08] bg-white/[0.02] p-8 md:p-12 text-center">
            <p className="text-2xl md:text-3xl font-bold text-white leading-snug max-w-2xl mx-auto">
              Подключите магазин за 2 минуты.
              <br />
              <span className="text-white/50">
                Через 15 минут увидите, какие товары вас кормят, а какие — съедают прибыль.
              </span>
            </p>
            <div className="flex flex-col sm:flex-row items-center justify-center gap-8 mt-10">
              <div>
                <div className="text-3xl font-bold text-white">2 мин</div>
                <div className="text-xs text-white/40 mt-1">подключение</div>
              </div>
              <div className="hidden sm:block w-px h-8 bg-white/[0.08]" />
              <div>
                <div className="text-3xl font-bold text-white">15 мин</div>
                <div className="text-xs text-white/40 mt-1">до первых данных</div>
              </div>
              <div className="hidden sm:block w-px h-8 bg-white/[0.08]" />
              <div>
                <div className="text-3xl font-bold text-white">30 дней</div>
                <div className="text-xs text-white/40 mt-1">бесплатно, без карты</div>
              </div>
            </div>
          </div>
        </ScrollReveal>
      </div>
    </section>
  );
}
